<div *ngIf="loadingVisible" class="backdrop"></div>
<div *ngIf="loadingVisible" class="spinner"></div>